// Common translations used across multiple pages (header, footer, etc.)

export default {
  // Header
  header: {
    home: "Home",
    company: "Company",
    sustainability: "Sustainability",
    products: "Products",
    ourServices: "Our Services",
    inquiryForm: "Inquiry Form",
    language: "Language"
  },
  
  // Footer
  footer: {
    quickLinks: "Quick Links",
    home: "Home",
    company: "Company",
    products: "Products",
    ourServices: "Our Services",
    sustainability: "Sustainability",
    inquiryForm: "Inquiry Form",
    officeHours: "Office Hours",
    mondayFriday: "Monday - Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    closed: "Closed",
    ourCertifications: "Our Certifications",
    allRightsReserved: "All Rights Reserved",
    subsidiaryOf: "A subsidiary of",
    designedBy: "Designed by"
  }
};